import React, { useState } from 'react';
import CategoryList from '../components/CategoryList';
import CategoryForm from '../components/CategoryForm';
import useWindowWidth from '../hooks/useWindowWidth';
import '../components/RevenueDesktop.css';

function CategoriesPage() {
  const [editingCategory, setEditingCategory] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const width = useWindowWidth();

  const handleEdit = (category) => {
    setEditingCategory(category);
    setShowForm(true);
  };

  const handleNewCategory = () => {
    setEditingCategory(null);
    setShowForm(true);
  };

  const handleSuccess = () => {
    setShowForm(false);
    setEditingCategory(null);
    // Optionally, refresh the category list here if it's not handled by a global state
  };

  const isDesktop = width >= 768;

  return (
    <div>
      {/* ── Desktop header ── */}
      {isDesktop && !showForm && (
        <div className="rv-page-header">
          <div className="rv-page-header-title">
            <h1>Categorias</h1>
            <p>Organize suas categorias financeiras</p>
          </div>
          <button className="rv-btn rv-btn-primary" onClick={handleNewCategory}>
            + Nova Categoria
          </button>
        </div>
      )}

      {/* ── Mobile header (mantido exatamente como era) ── */}
      {!isDesktop && <h1>Gerenciamento de Categorias</h1>}
      {!isDesktop && !showForm && (
        <button className="btn btn-success mb-3" onClick={handleNewCategory}>Adicionar Nova Categoria</button>
      )}

      {showForm ? (
        <div>
          {isDesktop
            ? <p className="rv-form-heading">{editingCategory ? 'Editar Categoria' : 'Nova Categoria'}</p>
            : <h2>{editingCategory ? 'Editar Categoria' : 'Criar Nova Categoria'}</h2>
          }
          <CategoryForm category={editingCategory} onSuccess={handleSuccess} />
          <button className="btn btn-secondary mt-3" onClick={() => setShowForm(false)}>Cancelar</button>
        </div>
      ) : (
        <CategoryList onEdit={handleEdit} />
      )}
    </div>
  );
}

export default CategoriesPage;
